import { render } from "./ExpertView.vue?vue&type=template&id=ffcf3aba"
import script from "./ExpertView.vue?vue&type=script&lang=js"
export * from "./ExpertView.vue?vue&type=script&lang=js"

import "./ExpertView.vue?vue&type=style&index=0&id=ffcf3aba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__